import { render } from "./Nota.vue?vue&type=template&id=223e5fd5"
import script from "@/assets/js/nota.js?vue&type=script&lang=js"
export * from "@/assets/js/nota.js?vue&type=script&lang=js"

import "./Nota.vue?vue&type=style&index=0&id=223e5fd5&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__